import React from 'react';

export interface CustomerContextType {
  customerId: string | null;
  setCustomerId: (customerId: string | null) => void;
  setOpenSearchCard: (open: boolean) => void;
  openSearchCard: boolean;
}

export const CustomerContext = React.createContext<CustomerContextType | undefined>(undefined);